
import { GPUOptions, Render, RenderInput, Shader, Unit, Plugin, RenderOutput, Tick, Resolution } from "./gpu"

export type HugoStateOptions = {
    television?: GPUOptions,
}

export type HugoState = {
    output: RenderInput,
    shaders: Shader[],
    plugins: Plugin[],
}

export type UseHugoState = (options: HugoStateOptions) => [HugoState, HugoStateApi, Tick]

export type HugoStateOutputOptions = {
    append?: boolean,
    plugins?: Shader[],
    shaders?: Shader[],
    tts?: boolean,
    initalTick?: number,
}
export type HugoStateOutput = (content: RenderInput, options?: HugoStateOutputOptions) => void

export type HugoStateApi = {
    output: HugoStateOutput,
    addRow: (row: Unit[], tts?: boolean) => void
    replaceLastRow: (row: Unit[], tts?: boolean) => void
    deleteRow: (index: number) => void
    render: (input: RenderInput,  shaders?: Shader[], plugins?: Plugin[],) => RenderOutput,
    clear: () => void,
    cancleTTS: () => void,
    addListener: (type: HugoEventType, listener: EventListener) => void,
    removeListener: (type: HugoEventType, listener: EventListener) => void,
    setShaders: (shaders: Shader[]) => void,
    setPlugins: (plugins: Plugin[]) => void,
    getResolution: () => Resolution
}

export enum HugoEventType {
    OnClick = 'hugo-onclick',
}